import { type FormEvent, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { type AutoClassifyProgress, autoClassifyStream } from '../api';
import Header from '../components/Header';

export default function AutoClassifierPage() {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [concept, setConcept] = useState('');
  const [running, setRunning] = useState(false);
  const [progress, setProgress] = useState<AutoClassifyProgress | null>(null);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!name.trim() || !concept.trim() || running) return;
    setRunning(true);
    setError(null);
    setProgress(null);
    try {
      await autoClassifyStream(name.trim(), concept.trim(), (event) => {
        setProgress(event);
      });
      navigate('/classifiers');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Auto-classify failed.');
    } finally {
      setRunning(false);
    }
  };

  return (
    <div className="page-filter-create">
      <Header />
      <Link className="back-link" to="/classifiers">
        &larr; Back to classifiers
      </Link>

      <h2>Auto-Generate Classifier</h2>

      <form onSubmit={handleSubmit}>
        <div className="filter-name-row">
          <label>
            Classifier name
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g. AI research"
              className="filter-name-input"
              disabled={running}
            />
          </label>
        </div>

        <div className="filter-name-row">
          <label>
            Concept
            <input
              type="text"
              value={concept}
              onChange={(e) => setConcept(e.target.value)}
              placeholder="e.g. tech layoffs, AI research, celebrity gossip"
              className="filter-name-input"
              disabled={running}
            />
          </label>
        </div>

        <div className="filter-create-actions">
          <button
            type="submit"
            className="save-btn"
            disabled={running || !name.trim() || !concept.trim()}
          >
            {running ? 'Generating...' : 'Generate Classifier'}
          </button>
        </div>
      </form>

      {error && <p className="error">{error}</p>}

      {progress && (
        <div className="auto-classify-progress">
          <p className="summary-loading">{progress.message}</p>
        </div>
      )}
    </div>
  );
}
